<template>
  <ul class="tutorials-category-list">
    <TutorialsListRow
      v-for="category in getStartedStore.visibleCategories"
      :key="category.id"
      :name="category.name"
      :secondary-text="category.subtitle"
      :trailing-text="`${getStartedStore.categoryProgress(category.id).completed} of ${getStartedStore.categoryProgress(category.id).total} complete`"
      :complete="getStartedStore.isCategoryComplete(category.id)"
      :data-cy="`tutorials-category-${category.id}`"
      @click="emit('select', category.id)"
    />
  </ul>
</template>

<script setup>
import { useGetStartedStore } from '@/stores/useGetStartedStore';

const emit = defineEmits(['select']);

const getStartedStore = useGetStartedStore();
</script>

<style lang="scss" scoped>
.tutorials-category-list {
  @apply tw-m-0 tw-list-none tw-p-0;
}
</style>
